<template>
  <!-- begin:: Footer -->
  <div class="footer bg-white py-2 d-flex flex-lg-column" id="kt_footer">
    <div
        class="d-flex align-items-center justify-content-between"
        :class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
<!--      <div class="text-dark">-->
<!--        <img v-bind:src="footerLogo" alt="Footer Text" height="50px" />-->
<!--      </div>-->
      <div class="nav nav-dark">
        <span class="text-muted font-weight-bold mr-2">
          {{ currentYear }} &nbsp;&copy;&nbsp;
        </span>
        <a v-if="brandInfo" :href="brandInfo.brandLink" target="_blank" class="text-dark-75 text-hover-primary">
          {{ brandInfo.brandFullName }}
        </a>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },

    // footerLogo() {
    //   return process.env.BASE_URL + "media/logos/<>.jpg";
    // },

    currentYear() {
      return new Date().getFullYear();
    },

    brandInfo () {
      return this.$store.state.wizardBrandInfo;
    }
  },
};
</script>
